export default "__VITE_ASSET__BurC_ZgQ__"